(function () {
  const SELECTORS = [
  '.product-card .product-title',
  '.product-card .product-card__short-description',
  '.product-card product-card-variant-form'
];
  const ROW_TOLERANCE = 5;

  function groupByRow(elements) {
    if (!elements.length) return [];
    const sorted = [...elements].sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
    const rows = [];
    let currentRow = [sorted[0]];
    let currentTop = sorted[0].getBoundingClientRect().top;

    for (let i = 1; i < sorted.length; i++) {
      const top = sorted[i].getBoundingClientRect().top;
      if (Math.abs(top - currentTop) <= ROW_TOLERANCE) {
        currentRow.push(sorted[i]);
      } else {
        rows.push(currentRow);
        currentRow = [sorted[i]];
        currentTop = top;
      }
    }
    rows.push(currentRow);
    return rows;
  }

  function alignElements(selector) {
    const elements = [...document.querySelectorAll(selector)];
    if (!elements.length) return;

    elements.forEach(el => (el.style.minHeight = ''));

    const rows = groupByRow(elements);
    rows.forEach(group => {
      if (group.length < 2) return;
      const maxHeight = Math.max(...group.map(el => el.scrollHeight));
      group.forEach(el => (el.style.minHeight = maxHeight + 'px'));
    });
  }

  function alignAll() {
    SELECTORS.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => (el.style.minHeight = ''));
    });

    requestAnimationFrame(() => {
      SELECTORS.forEach(sel => alignElements(sel));
    });
  }

  function alignAfterImages() {
    const images = document.querySelectorAll('.product-card img');
    const pending = [...images].filter(img => !img.complete);

    if (pending.length === 0) {
      alignAll();
      return;
    }

    let loaded = 0;
    const onLoad = () => {
      loaded++;
      if (loaded >= pending.length) alignAll();
    };
    pending.forEach(img => {
      img.addEventListener('load', onLoad, { once: true });
      img.addEventListener('error', onLoad, { once: true });
    });

    setTimeout(alignAll, 2000);
  }

  let debounceTimer;
  function debouncedAlign() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(alignAll, 150);
  }

  function init() {
    alignAfterImages();

    window.addEventListener('resize', debouncedAlign);

    const sectionEl = document.querySelector('.shopify-section--main-collection')
      || document.querySelector('.shopify-section--main-search');

    if (sectionEl) {
      const observer = new MutationObserver(() => {
        setTimeout(alignAfterImages, 50);
      });
      observer.observe(sectionEl, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', () => setTimeout(alignAfterImages, 200));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
